"use client";
import { jsx as e, Fragment as o } from "react/jsx-runtime";
import { createSvgIcon as r } from "@mui/material/utils";
const c = r(
  /* @__PURE__ */ e(o, { children: /* @__PURE__ */ e(
    "path",
    {
      d: "M17.5 1.79004H6.50004C3.90004 1.79004 1.79004 3.90004 1.79004 6.50004V17.5C1.79004 20.1 3.90004 22.21 6.50004 22.21H17.5C20.1 22.21 22.21 20.1 22.21 17.5V6.50004C22.21 3.90004 20.1 1.79004 17.5 1.79004ZM20.79 17.5C20.79 19.31 19.31 20.79 17.5 20.79H6.50004C4.69004 20.79 3.21004 19.31 3.21004 17.5V6.50004C3.21004 4.69004 4.69004 3.21004 6.50004 3.21004H17.5C19.31 3.21004 20.79 4.69004 20.79 6.50004V17.5Z",
      fill: "currentColor"
    }
  ) }),
  "KmxCheckboxCheckedStroked"
);
export {
  c as default
};
